module.exports = __webpack_public_path__ + "static/logos/logo-comscore-818534248f83d8fb53172657413ca7fc.png";